import { render, staticRenderFns } from "./generateSalesRecords.vue?vue&type=template&id=a318f4e6&scoped=true"
import script from "./generateSalesRecords.vue?vue&type=script&lang=js"
export * from "./generateSalesRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a318f4e6",
  null
  
)

export default component.exports